import React, { useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ScrapeFilters from "./ScrapeFilters";
import ScrapeTable from "./ScrapeTable";
import CreateScrapeModal from "./CreateScrapeModal";
import { ScrapeConfigFilters } from "../../Types/Scrapes";
import { useScrapeConfigsQuery, useAtsOptionsQuery, useCreateConfigMutation } from "../../Queries/ScrapeQueries";

export default function JobBoardScrapesPage() {
  const [filters, setFilters] = useState<ScrapeConfigFilters>({});
  const [clientSearch, setClientSearch] = useState("");
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [snackbar, setSnackbar] = useState<{ open: boolean; message: string; severity: "success" | "error" }>({
    open: false,
    message: "",
    severity: "success",
  });

  const { data: configs = [], isLoading } = useScrapeConfigsQuery(filters);
  const { data: atsOptions = [] } = useAtsOptionsQuery();
  const createMutation = useCreateConfigMutation();

  const filteredConfigs = clientSearch
    ? configs.filter((c) => c.clientName?.toLowerCase().includes(clientSearch.toLowerCase()))
    : configs;

  const handleCreate = (data: Parameters<typeof createMutation.mutate>[0]) => {
    createMutation.mutate(data, {
      onSuccess: () => {
        setCreateModalOpen(false);
        setSnackbar({ open: true, message: "Configuration created", severity: "success" });
      },
      onError: () => {
        setSnackbar({ open: true, message: "Failed to create configuration", severity: "error" });
      },
    });
  };

  return (
    <div className="page-container">
      <h1 className="page-title">Job Board Scrapes</h1>

      <div style={{ paddingRight: "8%" }}>
        <ScrapeFilters
          filters={filters}
          onFilterChange={setFilters}
          atsOptions={atsOptions}
          clientSearch={clientSearch}
          onClientSearchChange={setClientSearch}
          onNewScrape={() => setCreateModalOpen(true)}
        />

        <ScrapeTable configs={filteredConfigs} isLoading={isLoading} style={{ maxHeight: "calc(100vh - 220px)" }} />
      </div>

      <CreateScrapeModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
        onSubmit={handleCreate}
        atsOptions={atsOptions}
        isSubmitting={createMutation.isLoading}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snackbar.severity} onClose={() => setSnackbar((s) => ({ ...s, open: false }))}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
